import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { exchangePanelLogin } from "../api/account";
import { useAuth } from "../auth/useAuth";

/// Receives the native app's auto-login handoff. The single-use ticket arrives
/// in the URL **fragment** (`#…`), which the browser never sends to the server —
/// so it stays out of access logs. We read it, POST it in the request body to
/// exchange it for session cookies, scrub it from the address bar/history, then
/// land on the dashboard.
export default function HandoffCallback() {
  const navigate = useNavigate();
  const { markAuthenticated } = useAuth();
  // Read the ticket from the URL fragment once (a pure read); the effect scrubs
  // it from the address bar. Missing-token is an initial error state so we never
  // call setState synchronously inside the effect.
  const [token] = useState(() => window.location.hash.replace(/^#/, ""));
  const [error, setError] = useState(
    token ? "" : "This sign-in link is missing its token.",
  );

  useEffect(() => {
    // Drop the fragment immediately so the ticket isn't left in the URL/history.
    window.history.replaceState(null, "", window.location.pathname);
    if (!token) return;

    let cancelled = false;
    exchangePanelLogin(token)
      .then(async (result) => {
        if (cancelled) return;
        if (result.status === "two_factor_required") {
          sessionStorage.setItem("meridian_totp_challenge", result.challenge);
          navigate("/login?two_factor=1", { replace: true });
          return;
        }
        if (result.status !== "authenticated") {
          setError("Unexpected sign-in response.");
          return;
        }
        await markAuthenticated();
        navigate("/", { replace: true });
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err?.message || "This sign-in link is no longer valid.");
      });

    return () => {
      cancelled = true;
    };
  }, [token, markAuthenticated, navigate]);

  if (error) {
    return (
      <div className="login-page">
        <div className="login-card">
          <div className="login-header">
            <h1>Meridian</h1>
          </div>
          <div className="error-message">{error}</div>
          <button
            className="btn btn-primary"
            onClick={() => navigate("/login", { replace: true })}
          >
            Go to Sign In
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <h1>Meridian</h1>
          <p>Signing you in…</p>
        </div>
      </div>
    </div>
  );
}
